export default __webpack_public_path__ + "static/media/zoho.1683d806.png";